import { render, staticRenderFns } from "./Data-Source-Placeholder.vue?vue&type=template&id=6edf939b&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports